export default "__VITE_ASSET__DyZTJUPP__"